import { render, staticRenderFns } from "./index.vue?vue&type=template&id=276a42fa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=276a42fa&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276a42fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('276a42fa')) {
      api.createRecord('276a42fa', component.options)
    } else {
      api.reload('276a42fa', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=276a42fa&scoped=true", function () {
      api.rerender('276a42fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/detailComponent/detailBox/index.vue"
export default component.exports